




































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { FilterState } from '@/stores/modules/filter';
import { namespace } from 'vuex-class';

const filter = namespace('filter');

@Component
export default class CollectionFilter extends Vue {
  @Prop({ type: String }) collectionType!: 'chapter' | 'flow' | 'update';
  @Prop({ type: String }) title!: string;
  @Prop({ type: Array, required: true }) items!: string[];

  private selectedCollections: string[] = [];

  @filter.State(x => x.filter) currentFilter!: FilterState['filter'];
  @filter.Mutation('setFilterItem') setFilterItem!: (item: {
    key: keyof FilterState['filter'];
    val: string | string[];
  }) => void;

  @Watch(`currentFilter`, { deep: true })
  onSeperateFilterChange(val: FilterState['filter'], oldVal: FilterState['filter']) {
    this.selectedCollections = val[this.collectionType];
  }

  @Watch('selectedCollections')
  onSelectionChange(val: string[]) {
    this.setFilterItem({ key: this.collectionType, val });
  }
}
